var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Platform } from 'react-native';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
import { Focusable } from '../Focusable';
import { View } from '../View';
import { Header, Footer, Files, Awareness, Clock, Suggestion } from './components';
import { useFileInputContext, useMessageInputContext, useTextInputContext } from './hooks';
export const MessageInput = (_a) => {
    var { richTextEnabled, entitiesEnabled, footerDisabled, onOpenTemplates, onSaveTemplate, onOpenEntities, onUpload, templatesEnabled, style, awareness, clock, inputStyle, bookingEnabled, onBook, setMode, isAssistantEnabled, mode, onDismissSuggestion, suggestion, isSuggestionUsed, id } = _a, props = __rest(_a, ["richTextEnabled", "entitiesEnabled", "footerDisabled", "onOpenTemplates", "onSaveTemplate", "onOpenEntities", "onUpload", "templatesEnabled", "style", "awareness", "clock", "inputStyle", "bookingEnabled", "onBook", "setMode", "isAssistantEnabled", "mode", "onDismissSuggestion", "suggestion", "isSuggestionUsed", "id"]);
    const styles = useStyleSheet(getStyles);
    const { isFocused, showRichTextToolbar } = useMessageInputContext();
    const { editor } = useTextInputContext();
    const { files } = useFileInputContext();
    return (React.createElement(View, { style: [styles.container, style], nativeID: id },
        awareness ? (React.createElement(View, { style: styles.messageInputTopBar },
            React.createElement(Awareness, { data: awareness }))) : clock ? (React.createElement(View, { style: styles.messageInputTopBar },
            React.createElement(Clock, Object.assign({}, clock)))) : null,
        React.createElement(Focusable, { style: [styles.input, isFocused && styles.focus], pressStyle: styles.press, onPress: () => {
                if (editor)
                    editor.focus();
            } },
            richTextEnabled && showRichTextToolbar && (React.createElement(Header, { entitiesEnabled: entitiesEnabled, onOpenEntities: onOpenEntities, entities: props.entities })),
            suggestion ? (React.createElement(Suggestion, { title: suggestion.title, value: suggestion.value, onDismiss: onDismissSuggestion })) : null,
            props.editor,
            !!files.length && React.createElement(Files, null),
            !footerDisabled && (React.createElement(Footer, { templatesEnabled: templatesEnabled, onOpenTemplates: onOpenTemplates, onSaveTemplate: onSaveTemplate, onUpload: onUpload, richTextEnabled: richTextEnabled, templates: props.templates, bookingEnabled: bookingEnabled, onBook: onBook, mode: mode, setMode: setMode, onDismissSuggestion: onDismissSuggestion, isAssistantEnabled: isAssistantEnabled, isSuggestionUsed: isSuggestionUsed })))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {},
    input: Object.assign({ borderRadius: size.G, borderWidth: 1, borderColor: color.invert2.p4, padding: size.C, backgroundColor: color.bg.v1, flex: 1 }, Platform.select({
        web: {
            cursor: 'text',
            transitionProperty: [
                'outline-color',
                'background-color',
                'opacity',
                'border-color'
            ],
            transitionDuration: ['.25s', '.25s', '0ms', '.25s'],
            userSelect: 'auto'
        },
        ios: {},
        android: {}
    })),
    messageInputTopBar: {
        backgroundColor: color.bg.v2,
        borderTopLeftRadius: size.G,
        borderTopRightRadius: size.G,
        paddingBottom: size.G,
        marginBottom: -size.G
    },
    focus: { borderColor: color.invert2.p16 },
    press: {}
}));
export { useFileInputContext, useMessageInputContext, useTextInputContext };
export { MessageInputContextProvider, FileInputContextProvider, TextInputContextProvider } from './contexts';
export { EditorMode } from './types';
//# sourceMappingURL=index.js.map